import { render, staticRenderFns } from "./LoginLegalDocument.vue?vue&type=template&id=358f9e64"
import script from "./LoginLegalDocument.vue?vue&type=script&lang=js"
export * from "./LoginLegalDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports